import { render, staticRenderFns } from "./MicrosoftSuccess.vue?vue&type=template&id=5e4ac398&scoped=true"
import script from "./MicrosoftSuccess.vue?vue&type=script&lang=js"
export * from "./MicrosoftSuccess.vue?vue&type=script&lang=js"
import style0 from "./MicrosoftSuccess.vue?vue&type=style&index=0&id=5e4ac398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4ac398",
  null
  
)

export default component.exports